import { setupSearchForm } from './search_form';
import { setupPhotoGallery } from './photo_gallery';
import { initAccommodationList } from './accommodation_list';
import { initAccommodationDetail } from './accommodation_detail';
import { initAccommodationPlan } from './accommodation_plan';
import { initAccommodationPayment } from './accommodation_payment';


const ACCOMMODATIONS_PATH = 'accommodations';
const NEW_SNOWYADO_PATH = '/stay-packages/hotels';
const LIST_PATH = /snow\/resorts\/[a-z0-9-]+\/accommodations/
const DETAIL_PATH = /snow\/accommodations\/[a-zA-Z0-9]+\?/
const PLANS_PATH = /snow\/accommodations\/[a-zA-Z0-9]+\/plans\/[A-Za-z0-9_-]+/

export const initAccommodations = () => {
  if (location && (location.href.includes(ACCOMMODATIONS_PATH) || location.href.includes(NEW_SNOWYADO_PATH))) {
    const url = location.href;
    const gon = (window as any).gon;
    const pageType = gon.accommodationsPageType;

    setupPhotoGallery();

    // gonのpageTypeとurlをチェックすることで二重読み込みのバグを防止する
    if (LIST_PATH.test(url) && pageType === 'list') {
      initAccommodationList();
      return;
    }
    if ((DETAIL_PATH.test(url) || NEW_SNOWYADO_PATH) && pageType === 'detail') {
      initAccommodationDetail();
      return;
    }
    if (PLANS_PATH.test(url) && (pageType === 'plan' || pageType === 'order_new')) {
      initAccommodationPlan();
      return;
    }
    if (PLANS_PATH.test(url) && pageType === 'order_payment') {
      initAccommodationPayment();

      return;
    }
    if (PLANS_PATH.test(url) && pageType === 'booking_completed') {

      return;
    }

  } else if (location && location.href.includes('wechatpay_orders')) {
    const url = location.href;
    const gon = (window as any).gon;
    const pageType = gon.accommodationsPageType;

    setupPhotoGallery();

    if (/snow\/wechatpay_orders\/[0-9]+/.test(url) && pageType === 'order_new') {
      initAccommodationPayment();
      return;
    }
  }
}
